.container {
  background-color: var(--color-uva-white);
  border: 2px dotted var(--color-uva-black);
  overflow: auto;
  position: relative;
}

.container--padded {
  padding: 1rem;
}

.container--small {
  height: 10rem;
  width: 10rem;
}

.container--medium {
  height: 30rem;
  width: 30rem;
}

.container--large {
  height: 50rem;
  width: 50rem;
}

.container--large-full-height {
  width: 50rem;
}

.container--hidden {
  display: none;
}

.container--centered-content {
  align-items: center;
  display: flex;
  justify-content: center;
}
